export default {
  data: () => ({}),
  methods: {
    checkPermission (permission, type) {
      let hasPermission = true
      let permissions = this.getterPermissions.find((res) => {
        return res.id_text === permission
      })
      if (permissions) {
        hasPermission = permissions ? permissions[type] : true
      }
      return hasPermission
    }
  },
  computed: {
    getterAccess () {
      return this.$store.getters[`access/value`]
    },
    getterPermissions () {
      return this.$store.getters[`access/permissions`]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/access.js